'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CJK_HIRAGANA_REGEX = new RegExp(/[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]|[\u3040-\u309F]|[\u3005]|[\u3031-\u3032]/);

var KATAKANA_REGEX = new RegExp(/[\u30A0-\u30FF]/);

var KATAKANA_SEPARATOR = '・';

// Formats a first and last name depending on the character set.

exports.default = function (_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      email = _ref.email;

  var first = firstName && firstName.trim();
  var last = lastName && lastName.trim();
  if (!first && !last) {
    return email || '';
  } else if (first && !last) {
    return first;
  } else if (!first && last) {
    return last;
  } else if (CJK_HIRAGANA_REGEX.test(last) && (CJK_HIRAGANA_REGEX.test(first) || KATAKANA_REGEX.test(first))) {
    return last + '\u3000' + first;
  } else if (KATAKANA_REGEX.test(first) && KATAKANA_REGEX.test(last)) {
    return '' + first + KATAKANA_SEPARATOR + last;
  }

  return first + ' ' + last;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.233/js/utils/formatName.js
// module id = 286
// module chunks = 0